<template>
  <el-popover
    v-if="show"
    v-model="showDropdown"
    popper-class="dsf-page-home-header-user-info-panel"
    placement="bottom"
    trigger="hover"
  >
    <template #reference>
      <slot name="reference"></slot>
    </template>
    <slot>
      <div class="content">
        <div class="userinfo">
          <dsf-page-home-header-user>
            <div class="basic">
              <span class="username">{{ dsf.cookies.get("user_name") }}</span>
              <span v-show="currUnit" class="other-info">{{ currUnit }}</span>
            </div>
            <i
              class="to-editor iconfont icon-tianxie"
              @click="handleOpenUserInfoWindow"
            ></i>
          </dsf-page-home-header-user>
        </div>
        <div class="down-menu">
          <!-- 样式切换功能 -->
          <div class="down-menu-header">
            <div class="down-menu-bt">
              <i class="iconfont icon-nav-colour" style="color: #ff9900"></i>
              <span>主题</span>
              <div class="popover theme-radio-list" style="width: 160px">
                <template v-for="key in showThemes">
                  <div
                    :key="key"
                    class="theme-radio-item"
                    :style="radioStyle(dsf.themeConfig.themesConfig[key], key)"
                    @click="radioClick(key)"
                  ></div>
                </template>
              </div>
            </div>
            <div class="down-menu-bt">
              <i class="iconfont icon-icon_user_zt" style="color: #cc3399"></i>
              <span>字号</span>
              <div class="popover">
                <el-radio-group v-model="fontSizeVal">
                  <el-radio
                    v-for="(text, val) in fontSizeOptions"
                    :key="val"
                    :label="val"
                  >
                    {{ text }}
                  </el-radio>
                </el-radio-group>
              </div>
            </div>
            <div
              class="down-menu-bt"
              v-if="hasDefaultHeader || hasDefaultAside"
            >
              <i class="iconfont icon-zhinan" style="color: #3399cc"></i>
              <span>导航栏</span>
              <div class="popover">
                <template v-if="hasDefaultHeader">
                  <div class="title">顶部</div>
                  <el-radio-group v-model="themeConfig.defaultHeaderMini">
                    <el-radio :label="false">宽条</el-radio>
                    <el-radio :label="true">窄条</el-radio>
                  </el-radio-group>
                </template>
                <template v-if="hasDefaultAside">
                  <div class="title">侧边</div>
                  <el-radio-group v-model="themeConfig.defaultAsideMini">
                    <el-radio :label="false">宽条</el-radio>
                    <el-radio :label="true">窄条</el-radio>
                  </el-radio-group>
                </template>
              </div>
            </div>
          </div>
          <!-- dropdownConfig功能 -->
          <div class="down-menu-main">
            <div
              v-for="menu in menuList"
              :key="menu.key"
              class="down-menu-bt"
              @click="menu._clickHandler && menu._clickHandler(menu)"
            >
              <span>{{ menu.name }}</span>
              <template v-if="menu.children">
                <i class="iconfont icon-icon_more"></i>
                <div class="popover">
                  <div
                    v-for="it in menu.children"
                    :key="it.key"
                    class="popover-menu-bt"
                    @click="it._clickHandler && it._clickHandler(it, 1)"
                  >
                    <span>{{ it.groupName }}</span>
                    <template v-if="it.children && it.children.length">
                      <div class="popover popover-second">
                        <div
                          v-for="item in it.children"
                          :key="item.unitId"
                          class="popover-menu-bt"
                          @click="
                            item._clickHandler &&
                              item._clickHandler(it.groupId, item)
                          "
                        >
                          <span>{{ item.unitName }}</span>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div class="down-menu-footer" v-if="!hideLoginOutBt">
            <div class="down-menu-bt" @click="dropdownClick(loginOutBt)">
              退出登录
            </div>
          </div>
        </div>
      </div>
    </slot>
  </el-popover>
</template>

<script>
import themeSetting from "./themeSetting";
export default {
  name: "DsfPageHomeHeaderUserInfoPanel",
  mixins: [themeSetting],
  props: {
    dropdownConfig: {
      type: [Array, String],
      default: "",
    },
  },
  data() {
    return {
      showDropdown: false,
      loginOutBt: null,
      groups: {},
      groupIndex: -1,
      currUnit: null,
    };
  },
  created() {
    this.groupIndex = _.findIndex(this.relayDropdownConfig, (o) => {
      return o.key == "groupChange";
    });
    if (this.groupIndex > -1) {
      this.handleGetGroups();
    }
  },
  computed: {
    menuList() {
      let res = [];
      _.forEach(this.relayDropdownConfig, (it) => {
        it = _.clone(it);
        if (!it.handler && this[it.key]) {
          this[it.key]?.(it);
        } else {
          it._clickHandler = this.dropdownClick;
        }
        if (it.key !== "loginOut") {
          res.push(it);
        } else {
          this.loginOutBt = it;
        }
      });
      return res;
    },
    relayDropdownConfig() {
      if (!this.dropdownConfig) {
        if (+dsf.config.setting_public_hidden_update_password) {
          // 隐藏修改密码
          return [
            {
              name: "切换组",
              key: "groupChange",
            },
          ];
        } else {
          return [
            { name: "切换组", key: "groupChange" },
            {
              name: "修改密码",
              key: "alterPwd",
            },
          ];
        }
      } else {
        return this.dropdownConfig;
      }
    },
    hideLoginOutBt() {
      return +dsf.config.setting_public_hidden_logout;
    },
  },
  methods: {
    dropdownClick(obj) {
      this.$parent.$emit("dropdown-click", obj);
    },

    groupChange(obj) {
      // console.log(obj, 111);
      // obj.children = [
      //   { key: "group1", name: "校内教师" },
      //   { key: "group2", name: "导师" },
      //   { key: "group3", name: "培训师" },
      // ];
    },
    // 切换组改变子项
    groupChangeItem(groupId, obj) {
      if (!obj) {
        // 只有一个组且组只有一个机构时
        let grounp = groupId.data[0];
        groupId = grounp.groupId;
        obj = grounp.unitInfoList[0];
      } else if (obj === 1) {
        // 有多个组且当前组只有一个机构时
        let grounp = groupId;
        groupId = grounp.groupId;
        obj = grounp.unitInfoList[0];
      }
      this.handleGetMenus(groupId, obj.unitGlobalId);
      // 把当前选中值传出去
      this.dropdownClick(obj);
    },
    alterPwd(obj) {
      obj._clickHandler = () => {
        dsf.layer.openDialog({
          title: "修改密码",
          width: "600px",
          height: "500px",
          params: {
            path: "pc/dsfa/platformhome/alterPassword",
          },
        });
      };
    },
    // 打开用户详情窗口
    handleOpenUserInfoWindow() {
      // 获取信息编辑地址
      this.$http.get("/user/quickEdit").done((res) => {
        if (res.success) {
          this.$openDialog({
            title: "信息编辑",
            showClose: true,
            top: "5vh",
            height: "820px",
            width: "1230px",
            params: {
              path: res.data,
            },
          });
        } else {
          dsf.layer.message("获取地址失败", false);
        }
      });
    },
    // 获取当前角色的所有分组
    handleGetGroups() {
      this.$http
        .get(dsf.config.setting_public_group_list_src || "/oua2/groupList")
        .done((res) => {
          if (res.success) {
            // 添加事件类型
            let grounp = this.menuList[this.groupIndex];
            this.currUnit = res.data?.currentGroupName;
            let data = res.data.appUnitGroupInfoList;
            if (!data || !data.length) {
              _.forEach(this.menuList, (list, i) => {
                if (list.key == "groupChange") {
                  this.menuList.splice(i, 1);
                  return false;
                }
              });
              return;
            }
            this.groups.groupChange = data.map((item) => {
              if (data.length == 1 && item.unitInfoList?.length == 1) {
                // 只有一个组、且组只有一个机构的时候
                this.menuList[this.groupIndex]._clickHandler =
                  this.groupChangeItem;
                grounp.data = data;
              } else {
                if (item.unitInfoList?.length == 1) {
                  // 不止有一个组、但是这个组只有一个机构的时候
                  item._clickHandler = this.groupChangeItem;
                } else {
                  // 原有代码
                  item.children = item.unitInfoList;
                  item.children.forEach((it) => {
                    it._clickHandler = this.groupChangeItem;
                  });
                }
              }
              return item;
            });
            if (!grounp.data) {
              grounp.children = data;
            }
          } else {
            dsf.layer.message("获取角色组失败", false);
          }
        });
    },
    // 根据切换组获取新菜单
    // ps: 直接刷新页面就好，后端通过获取菜单方法更新当前分组菜单
    handleGetMenus(groupId, unitGlobalId) {
      dsf.layer
        .confirm({
          message: `该操作会刷新当前页面，是否继续该操作？`,
          confirmButtonText: "是",
          cancelButtonText: "否",
        })
        .then(() => {
          let oldMeut = dsf.storage.session.get("homeMenu");
          dsf.storage.session.remove("homeMenu");
          this.$http
            .post(
              dsf.config.setting_public_switch_group_src || "/oua2/switchGroup",
              { groupId, unitGlobalId }
            )
            .done((res) => {
              if (res.success) {
                setTimeout(function () {
                  location.replace("");
                }, 500);
              } else {
                dsf.storage.session.set("homeMenu", oldMeut);
                dsf.layer.message(res.message, false);
              }
            });
        });
    },
  },
};
</script>